import { NavLink } from "react-router-dom";
import { Heart, ArrowRight } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { ProductCard } from "@/components/ProductCard";
import { useWishlist } from "@/lib/wishlistContext";
import { products } from "@/data/products";

export default function Wishlist() {
  const { ids } = useWishlist();
  const wishlisted = products.filter((p) => ids.has(p.id));

  return (
    <div className="min-h-screen flex flex-col bg-stone-50">
      <Navbar />
      <main className="flex-1">
        <div className="bg-white border-b border-stone-100 py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <p className="text-[10px] tracking-[0.3em] uppercase text-emerald-600 font-semibold mb-2">Brupa</p>
            <h1 className="font-semibold text-2xl sm:text-3xl md:text-4xl md:font-bold text-stone-900 tracking-tight">
              Preferiti {wishlisted.length > 0 && <span className="text-stone-400 text-2xl">({wishlisted.length})</span>}
            </h1>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          {wishlisted.length === 0 ? (
            <div className="flex flex-col items-center gap-6 py-20 text-center">
              <Heart className="size-16 text-stone-200" />
              <div>
                <h2 className="font-medium text-lg sm:text-xl md:text-2xl md:font-semibold text-stone-700 tracking-tight mb-2">
                  Nessun preferito salvato
                </h2>
                <p className="text-stone-400 text-sm">
                  Clicca sul cuore su un prodotto per aggiungerlo ai tuoi preferiti.
                </p>
              </div>
              <NavLink
                to="/shop"
                className="inline-flex items-center gap-2 text-[10px] tracking-widest uppercase bg-stone-900 text-white px-8 py-3.5 hover:bg-stone-700 transition-colors"
              >
                Esplora la collezione <ArrowRight className="size-3.5" />
              </NavLink>
            </div>
          ) : (
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
              {wishlisted.map((product) => (
                <ProductCard key={product.id} product={product} />
              ))}
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
